
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'WhatsappIcon' })
export default class WhatsappIcon extends Vue {}
